export { DeliveryStoreSelectorModal as default } from 'features/store/pages/delivery-store-selector';
